<template>
  <el-select
    v-model="_value"
    class="my-select"
    :style="_style"
    v-bind="$attrs"
    :clearable="clearable"
    :disabled="disabled"
    :multiple="multiple"
    :filterable="filterable"
    :collapse-tags="collapseTags"
    @change="change"
    @blur="blur"
  >
    <template v-if="noLabel">
      <el-option
        v-if="allOption"
        :label="$t('components.global.all')"
        value=""
      />
      <el-option
        v-for="(item,index) in options"
        :key="index"
        :label="item"
        :value="item"
      />
    </template>
    <template v-else>
      <el-option
        v-if="allOption"
        :label="$t('components.global.all')"
        value=""
      />
      <el-option
        v-for="(item,index) in options"
        :key="index"
        :label="typeof item === 'object' ? item[keyValue.label]: item"
        :value="typeof item === 'object' ? item[keyValue.value]: item"
      />
    </template>
  </el-select>
</template>

<script>
export default {
  name: 'SelectItem',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number | Array | Boolean,
      default: function() {
        return ''
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    keyValue: {
      // 自定义枚举的 label、value的key值，无需对数据进行额外转化
      type: Object,
      default: function() {
        return { label: 'label', value: 'value' }
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '280px'
    },
    height: {
      type: String,
      default: '40px'
    },
    styleSheet: {
      type: Object,
      default: function() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    allOption: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-type-constructor
    data: String | Array | Object | Boolean
  },
  data() {
    return {}
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    _style() {
      return Object.assign(
        {},
        {
          width: this.width,
          height: this.height,
          'line-height': this.height
        },
        this.styleSheet
      )
    }
  },
  methods: {
    change(val) {
      console.log('change emit selecttem', val)
      this._value = val
      if (this.data) {
        this.$emit('change', { value: val, data: this.data })
      } else {
        this.$emit('change', val)
      }
    },
    blur() {
      this.$emit('blur')
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep.my-select.el-select {
  height: 32px;
  width: 184px;
  display: flex;

  .el-input__inner {
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 20px;
  }

  .el-input__suffix {
    line-height: 32px;
    display: flex;
    justify-content: center;
  }

  .el-select__caret {
    line-height: 32px;
  }

  .el-tag {
    max-width: 70%;
    text-align: left;
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    > span {
      // width: 80%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }

    .el-tag__close.el-icon-close {
      width: 14px;
      height: 14px;

      // top: -5px;
      // right: 0px;
    }
  }

  .el-tag:nth-child(2) {
    max-width: 70%;

    > span {
      width: 100%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .el-tag--small {
    font-size: 11px;
    height: 20px;
    line-height: 18px;
  }

  .el-icon-close {
    width: 14px;
    height: 14px;
  }
}
</style>
